import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
export const firebaseConfig = {
  apiKey: "AIzaSyCdpRC9ixCB_D6jfFBVvZ8h6qDH_EzQXbk",
  authDomain: "sptravel-erp.firebaseapp.com",
  projectId: "sptravel-erp",
  storageBucket: "sptravel-erp.firebasestorage.app",
  messagingSenderId: "687877186922",
  appId: "1:687877186922:web:a44f8448445897c01fb113"
};
export const firebaseApp = initializeApp(firebaseConfig);
export const auth = getAuth(firebaseApp);
export const db = getFirestore(firebaseApp);
export const storage = getStorage(firebaseApp);
